import { createContext, useContext } from "react";

export interface MobileSidebarContextValue {
  /**
   * Zamyka menu mobilne. Poza Sidebarem (np. na desktopie) jest no-op.
   * Wołane przy nawigacji do sekcji, aby zdjąć blokadę scrolla tła
   * i pozwolić na przewinięcie strony do wybranego elementu.
   */
  closeMobileMenu: () => void;
}

export const MobileSidebarContext = createContext<MobileSidebarContextValue>({
  closeMobileMenu: () => {},
});

export const useMobileSidebar = () => useContext(MobileSidebarContext);
